import { Fragment } from 'react';

import { UbexMediaSmallDark, UbexMediaLgDark } from '../../../assets/icons';
import { app as $appContent } from '../../../content';
import { clsm } from '../../../utils';
import { useUser } from '../../../contexts/User';
import Button from '../../../components/Button';
import ProfileMenu from '../../../components/ProfileMenu';
import UserAvatar from '../../../components/UserAvatar';
import { HAIRLINE_DIVIDER_CLASSES } from '../../../components/ProfileMenu/ProfileMenuTheme';
import { navPageData } from './utils';
import Tooltip from '../../../components/Tooltip';

const $content = $appContent.navbar;

const Sidebar = () => {
  const { userData, isSessionValid } = useUser();
  const { given_name: avatarName, family_name: lastName } = userData || {};
  const avatarSrc = '';
  const hasAvatar = !!avatarSrc;
  const renderWithTooltip = (component, message) =>
    isSessionValid ? (
      <Tooltip translate={{ y: 12 }} position="above" message={message}>
        {component}
      </Tooltip>
    ) : (
      component
    );

  return (
    <nav
      className={clsm(
        [
          'fixed',
          'flex',
          'flex-col',
          'items-center',
          'justify-between',
          'h-auto',
          'top-0',
          'bottom-0',
          'left-0',
          'overflow-y-auto',
          'overflow-x-hidden',
          'z-50',
          'dark:bg-[#2A2B32]',
          'supports-overlay:overflow-y-overlay'
        ],
        isSessionValid
          ? ['w-16', 'pt-7', 'pb-4', 'px-2.5']
          : ['w-60', 'pt-10', 'pb-6', 'px-4', 'lg:portrait:w-40']
      )}
    >
      {isSessionValid ? <UbexMediaSmallDark /> : <UbexMediaLgDark />}
      <div
        className={clsm([
          'flex',
          'flex-col',
          'items-center',
          'py-6',
          'space-y-6',
          'w-full'
        ])}
      >
        {navPageData.map(
          ({ pageName, displayName, icon, route, isAuth, target }, i) => {
            const isActive = true;
            // const isVisible = isAuth ? isSessionValid : true;

            return (
              //isVisisble
              true && (
                <Fragment key={displayName}>
                  {renderWithTooltip(
                    <Button
                      ariaLabel={`Go to the ${displayName} page`}
                      data-testid={`${pageName}-button`}
                      type="nav"
                      to={route}
                      variant="tertiaryText"
                      target={target}
                      className={clsm(
                        [
                          'w-10',
                          'h-10',
                          'min-w-full',
                          'py-1.5',
                          'rounded-full'
                        ], // Default styles
                        isSessionValid ? 'px-1.5' : 'px-3',
                        isActive &&
                          'bg-darkMode-blue hover:dark:bg-darkMode-blue-hover'
                      )}
                    >
                      <span
                        className={clsm(
                          [
                            'flex',
                            'items-center',
                            'space-x-3',
                            'w-full flex justify-center items-center'
                          ],
                          isActive
                            ? [
                                'text-darkMode-blue',
                                '[&>svg]:fill-darkMode-blue'
                              ]
                            : [
                                'text-black',
                                'dark:text-white',
                                'dark:[&>svg]:fill-white',
                                '[&>svg]:fill-black'
                              ]
                        )}
                      >
                        <img
                          src={icon}
                          alt={`${displayName} icon`}
                          className={clsm(
                            'w-6',
                            'h-6',
                            'object-contain',
                            'dark:brightness-0 dark:invert'
                          )}
                        />
                        {!isSessionValid && (
                          <span className="ml-3">{displayName}</span>
                        )}
                      </span>
                    </Button>,
                    displayName
                  )}
                </Fragment>
              )
            );
          }
        )}
      </div>
      <div className="flex flex-col items-center space-y-4 w-full">
        <span className={clsm(HAIRLINE_DIVIDER_CLASSES)} />
        {isSessionValid ? (
          <>
            <ProfileMenu
              asPortal
              menuClassName={clsm([
                'fixed',
                'bottom-6',
                'left-6',
                'w-[236px]',
                'origin-bottom-left'
              ])}
              navData={[
                {
                  label: $content.settings,
                  to: '/settings'
                }
              ]}
            >
              {({ isOpen, toggle, toggleRef }) => (
                <Button
                  ariaLabel={`${isOpen ? 'Close' : 'Open'} navigation menu`}
                  className={clsm(
                    [
                      'dark:bg-darkMode-gray',
                      'dark:shadow-white',
                      'focus:shadow-focusOuter',
                      'h-8',
                      'p-0',
                      'shadow-black',
                      'w-8'
                    ],
                    isOpen && 'shadow-focusOuter',
                    !hasAvatar && ['dark:hover:bg-darkMode-gray-hover']
                  )}
                  data-testid="sidebar-avatar"
                  onClick={() => toggle()}
                  variant="icon"
                  ref={toggleRef}
                >
                  <UserAvatar
                    userName={`${avatarName} ${lastName}`}
                    profileColor={'default'}
                  />
                </Button>
              )}
            </ProfileMenu>
          </>
        ) : (
          <div
            className={clsm([
              'flex',
              'flex-col',
              'space-y-4',
              'w-full',
              'dark:bg-darkMode-gray-medium',
              '[&>a]:w-full',
              '[&>a]:flex-1'
            ])}
          >
            <Button
              type="nav"
              variant="secondary"
              to="/login"
              saveLocationFromState
            >
              {$content.log_in}
            </Button>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Sidebar;
